<template>
  <v-alert
    value="true"
    color="info"
    icon="fas fa-info-circle"
    outline
    class="mt-5"
  >
    <span class="font-italic font-weight-bold">Notice:</span> If you already
    have a Nevada licensed realtor representing you, this is not a solicitation
    for a listing.
  </v-alert>
</template>

<script>
export default {
  name: 'AgentDisclaimer',
};
</script>
